import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useContent() {
  return useQuery({
    queryKey: ["content"],
    queryFn: async () => (await api.get("/content")).data,
    staleTime: Infinity,
  });
}
